export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';
export const CHANGE_ACIENT = 'CHANGE_ACIENT';
export const SET_CHAT_USER_SPEAKING = 'SET_CHAT_USER_SPEAKING';
export const SET_CHAT_SPEECH_DETECT = 'SET_CHAT_SPEECH_DETECT';
export const SET_CHAT_SENDER_LANG = 'SET_CHAT_SENDER_LANG';
export const SET_CHAT_TRANSLATOR_STATUS = 'SET_CHAT_TRANSLATOR_STATUS';
export const SET_LANGUAGE_GENDER = 'SET_LANGUAGE_GENDER';
export const SET_START_SPEECH_TIMER = 'SET_START_SPEECH_TIMER';

